import _ from 'lodash'
import { IdNameEntity } from './IdNameEntity'
import { Association } from './Association'
import { Member } from './Member'

class Sector extends IdNameEntity {
    constructor({ id, name, sector_info, contacts, associations }) {
        super({
            id,
            name
        })
        this.description = sector_info
        this.contacts = contacts ? contacts.map(contact => new Member(contact)) : []
        this.associations = associations
            ? associations.map(association => new Association(association))
            : []
    }

    get htmlDescription() {
        return { __html: this.description }
    }

    get truncatedDescription() {
        return _.truncate(this.description, {
            length: 300,
            separator: /\./,
            omission: '.'
        })
    }

    get htmlTruncatedDescription() {
        return { __html: this.truncatedDescription }
    }
}

export { Sector }
